import { ITmpAccount } from '@/container/Member/member';
import { ILog } from '@/container/UserPage/components/AccountLogs/log';
import { IPOAccount, IPOTag } from '@hylaa-npm/ipod';
import { request } from './index';
const accountUrls = {
	addAccount: '/account/add',
	accountLog: '/account/log/get',

	getStaffs: (state: 0 | 1) => `account/staff/state/${state}/list`,
	addStaff: '/account/staff/add',
	getStaff: (id: string) => `/account/staff/${id}/get`,
	changeStaffStatus: (id: string, type: 'disable' | 'enable') => `/account/staff/${id}/${type}`,
	changeStaffRole: (id: string) => `/account/staff/${id}/role/update`,
	changeStaffBasic: (id: string) => `/account/${id}/update`,
	resetStaffPwd: (id: string) => `/account/${id}/password/reset`,
	updateMobile: '/account/mobile/update',

	getUser: (id: string) => `/account/${id}/get`,
	updateInfo: (id: string) => `/account/${id}/update`,
	accountAddTag: (id: string) => `/account/${id}/tag/add`,
	accountDelTag: (id: string, tagId: string) => `/account/${id}/tag/${tagId}/rm`,
	delTmpAccount: (id: string) => `/account/tmp/${id}/rm`,
	accountProject: (id: string) => `/account/${id}/projects`,

	// 成员标准库
	getOfficials: '/account/official/list',
	getTmpAccountList: '/account/tmp/list',
	addOfficial: '/account/official/add',
	// getAccountTmpDateil: '/account/tmp/${id}/get',
	getOfficialDateil: (officialId: string) => `/account/official/${officialId}/get`,
	// addTempAccount: '/account/tmp/add',
	tagTmpTypeList: (type: 1 | 2) => `/tag/tmp/type/${type}/list`,
	accountUpdatePassword: '/account/password/update',
	getMemberDetail: (id: string) => `/project/team/member/${id}/get`,
};

/**
 * 添加员工
 * @param params IStaff
 */
export const addAccount = (params: IPOAccount.IAddStaff): Promise<IPOAccount.IAccount> => {
	return new Promise((resolve) => {
		request(accountUrls.addAccount, { body: params }).then((res) => {
			resolve((res as unknown) as IPOAccount.IAccount);
		});
	});
};

interface IListPromise {
	list: IPOAccount.IStaff[];
	pagination: IPagination;
}

export const getStaffs = (
	state: 0 | 1,
	params: string,
	pagination?: IPagination,
): Promise<IListPromise> => {
	return new Promise((resolve) => {
		request(accountUrls.getStaffs(state), { body: params, pagination }).then((res) => {
			resolve(res as IListPromise);
		});
	});
};

/**
 * 添加员工
 * @param params IStaff
 */
export const addStaff = (params: IPOAccount.IAddStaff): Promise<IPOAccount.IStaff> => {
	return new Promise((resolve) => {
		request(accountUrls.addStaff, { body: params }).then((res) => {
			resolve((res as unknown) as IPOAccount.IStaff);
		});
	});
};

/**
 * 获取员工详情
 * @param params IStaff
 */
export const getStaff = (id: string): Promise<IPOAccount.IStaff> => {
	return new Promise((resolve) => {
		request(accountUrls.getStaff(id), {}, 'get').then((res) => {
			resolve((res as unknown) as IPOAccount.IStaff);
		});
	});
};

/**
 * 禁用启用员工
 * @param params IStaff
 */
export const changeStaffStatus = (id: string, type: 'disable' | 'enable'): Promise<null> => {
	return new Promise((resolve) => {
		request(accountUrls.changeStaffStatus(id, type), {}, 'get').then((res) => {
			resolve((res as unknown) as null);
		});
	});
};

/**
 * 修改权限
 * @param params id: string
 */
export const changeStaffRole = (id: string, role: IPOAccount.StaffRoleEnum): Promise<null> => {
	return new Promise((resolve) => {
		request(accountUrls.changeStaffRole(id), { body: role }, 'post').then((res) => {
			resolve((res as unknown) as null);
		});
	});
};

/**
 * 修改员工信息
 * @param params id: string
 */
export const changeStaffBasic = (
	id: string,
	params: IPOAccount.IEditAccount,
): Promise<IPOAccount.IStaff> => {
	return new Promise((resolve) => {
		request(accountUrls.changeStaffBasic(id), { body: params }).then((res) => {
			resolve((res as unknown) as IPOAccount.IStaff);
		});
	});
};

/**
 * 重置员工密码
 * @param params id: string
 */
export const resetStaffPwd = (id: string, pwd: string): Promise<null> => {
	return new Promise((resolve) => {
		request(accountUrls.resetStaffPwd(id), { body: pwd }).then((res) => {
			resolve((res as unknown) as null);
		});
	});
};

/**
 * 变更记录
 * @returns
 */
export const getAccountLog = (): Promise<ILog[]> => {
	return new Promise((resolve) => {
		request(accountUrls.accountLog, undefined, 'get').then((res) => {
			resolve((res as unknown) as ILog[]);
		});
	});
};

/**
 * 获取个人信息
 * @param id
 * @returns
 */
export function getUser(id: string) {
	return new Promise((resolve) => {
		request(accountUrls.getUser(id), {}, 'get')
			.then((res) => {
				resolve(res);
			})
			.catch((e) => {});
	});
}
/**
 * 修改手机号
 * @param body
 * @returns
 */
export function updateMobile(body: { mobile: string; areaCode: string; code: string }) {
	return new Promise((resolve) => {
		request(accountUrls.updateMobile, { body: body })
			.then((res) => {
				resolve(res);
			})
			.catch((e) => {});
	});
}
/**
 * 修改信息
 * @param id
 * @param body
 * @returns
 */
export function updateInfo(
	id: string,
	body: { name: string; name2: string; email: string; avatar: string },
) {
	return new Promise((resolve) => {
		request(accountUrls.updateInfo(id), { body: body })
			.then((res) => {
				resolve(res);
			})
			.catch((e) => {});
	});
}
/**
 * 添加标签
 * @param id
 * @param tagId
 * @returns(id: string, pwd: string): Promise<null>
 */
export const accountAddTag = (
	accountId: string,
	tagId: string,
): Promise<IPOAccount.IAccount & { tags: IPOTag.ITag[] }> => {
	return new Promise((resolve) => {
		request(accountUrls.accountAddTag(accountId), { body: tagId })
			.then((res) => {
				resolve((res as unknown) as IPOAccount.IAccount & { tags: IPOTag.ITag[] });
			})
			.catch((e) => {});
	});
};
/**
 * 删除标签
 * @param id
 * @param tagId
 * @returns
 */
export function accountDelTag(id: string, tagId: string) {
	return new Promise((resolve) => {
		request(accountUrls.accountDelTag(id, tagId), {}, 'get')
			.then((res) => {
				resolve(res);
			})
			.catch((e) => {});
	});
}
// 删除临时成员
export function delTmpAccount(id: string) {
	return new Promise((resolve) => {
		request(accountUrls.delTmpAccount(id), {}, 'get')
			.then((res) => {
				resolve(res);
			})
			.catch((e) => {});
	});
}
export function accountProject(id: string) {
	return new Promise((resolve) => {
		request(accountUrls.accountProject(id), {}, 'get')
			.then((res) => {
				resolve(res);
			})
			.catch((e) => {});
	});
}
export function tagTmpTypeList(type: 1 | 2) {
	return new Promise((resolve) => {
		request(accountUrls.tagTmpTypeList(type), {}, 'get')
			.then((res) => {
				resolve(res);
			})
			.catch((e) => {});
	});
}

/**
 *** ============================成员标准库==========================
 */

// 获取成员标准库列表
export interface IOfficialAccountPromise {
	list: IPOAccount.IMember[];
	pagination: IPagination;
}

export interface IOfficialAccountParams {
	name: string;
	team: string;
	ability: string;
}

export const getOfficialAccounts = (
	params: IOfficialAccountParams,
	pagination?: IPagination,
): Promise<IOfficialAccountPromise> => {
	return new Promise((resolve) => {
		request(accountUrls.getOfficials, { body: { filters: params }, pagination }).then((res) => {
			resolve(res as IOfficialAccountPromise);
		});
	});
};

export interface ITmpAccountPromise {
	list: ITmpAccount[];
	pagination: IPagination;
}

// 获取临时成员标准库列表
export const getTmpAccounts = (
	params: string,
	pagination?: IPagination,
): Promise<ITmpAccountPromise> => {
	return new Promise((resolve) => {
		request(accountUrls.getTmpAccountList, { body: params, pagination }).then((res) => {
			resolve(res as ITmpAccountPromise);
		});
	});
};

/**
 * 从临时同步到标准库
 * @param id  成员id string 必传
 */

export interface IAddOfficialMemberFromTmp {
	id: string;
	accountId: string;
	addState: 0 | 2;
}

export const addOfficial = (id: string): Promise<IAddOfficialMemberFromTmp> => {
	return new Promise((resolve) => {
		request(accountUrls.addOfficial, { body: { id } }).then((res) => {
			resolve(res as IAddOfficialMemberFromTmp);
		});
	});
};

/**
 * 获取标准库单个成员信息
 * @param id 成员id string 必传
 */
export const getOfficialMemberDateil = (officialId: string): Promise<unknown> => {
	return new Promise((resolve) => {
		request(accountUrls.getOfficialDateil(officialId), undefined, 'get').then((res) => {
			resolve(res as ITmpAccount);
		});
	});
};

export const accountUpdatePassword = (body: { oldPass: string; newPass: string }) => {
	return new Promise((resolve) => {
		request(accountUrls.accountUpdatePassword, { body })
			.then((res) => {
				resolve(res);
			})
			.catch((e) => {});
	});
};
export const getMemberDetail = (id: string) => {
	return new Promise((resolve) => {
		request(accountUrls.getMemberDetail(id), {}, 'get')
			.then((res) => {
				resolve(res);
			})
			.catch((e) => {});
	});
};
